import Contentful from './contentful';
import Firebase from './firebase/firebase';

const CONTENTFUL_CONTENT_TYPE = 'contact';

function Contact() {
  Contentful.call(this);
  Firebase.call(this);
}

// Single inheritance
Contact.prototype = Object.create(Contentful.prototype, {
  contentType: {
    value: CONTENTFUL_CONTENT_TYPE,
  },
});

// Multiple inheritance !
Object.assign(Contact.prototype, Firebase.prototype);

Contact.prototype.constructor = Contact;

Contact.prototype.get = async function get() {
  return (await this.entries()).filterLatest().filterFields().data();
};

Contact.prototype.submit = async function submit(formData) {
  return this.call('contactSubmit', formData);
};

export default Contact;
